//React
import { useEffect, useMemo, useState } from "react";
import { useRoutes } from "react-router-dom";
// theme
import ThemeConfig from "./theme";
import GlobalStyles from "./theme/globalStyles";
import ScrollToTop from "./components/ScrollToTop";
import { BaseOptionChartStyle } from "./components/charts/BaseOptionChart";
//Apollo
import { ApolloProvider } from "@apollo/client";
import client from "./api/apollo";
//Comfig
import AuthContext from "./context/Auth.context";
import routes from "./routes";
import { decodeToken, getToken, removeToken, getMenuBar } from "./utils/token";
import Login from "./pages/Login";
function App() {
  //Validar el inicio de sesion
  const [auth, setAuth] = useState(undefined);
  const [sideBarMenu, setSideBarMenu] = useState(undefined);
  useEffect(() => {
    const token = getToken();
    const menuBar = getMenuBar();
   
    if (!token) {
      setAuth(null);
    } else {
      setAuth(decodeToken(token));
      setSideBarMenu(menuBar);
    }
  }, []);
  const logout = () => {
    removeToken();
    setAuth(null);
  };

  const setUser = (user) => {
    setAuth(user);
  };

  const setSideBar = (menusidebar) => {
    setSideBarMenu(menusidebar);
  };

  // const verificarToken = () => {
  //   return verifyToken();
  // };

  //Memo
  const authData = useMemo(
    () => ({
      auth,
      sideBarMenu,
      setSideBar,
      logout,
      setUser,
    }),
    [auth, sideBarMenu]
  );

  

  const routing = useRoutes(routes(sideBarMenu));
  return (
    <ApolloProvider client={client}>
      <AuthContext.Provider value={authData}>
        <ThemeConfig>
          <ScrollToTop />
          <GlobalStyles />
          <BaseOptionChartStyle />
          {!auth ? <Login /> : routing}
        </ThemeConfig>
      </AuthContext.Provider>
    </ApolloProvider>
  );
}

export default App;
